export default __webpack_public_path__ + "static/media/AGE.5b85794a.pdf";